/*
Product list からも Product item からも指定できる共通 props
*/
export default {
  props: {
    /*
    List item display config
    */
    // リンク先ターゲット
    target: {
      type: String
    },
    // 商品アイテムに追加で指定したいクラス（半角スペースorカンマ区切り）
    itemClasses: {
      type: String,
      default: ''
    },
    // 商品アイテムのプレースホルダー時に指定したいスタイル
    itemPlaceholderStyle: {
      type: String
    },
    // サムネイルサイズの指定
    // default: 300
    thumbnailSize: {
      type: String,
      default: '300'
    },

    // ブロック全体を包囲するAリンクブロックを表示するかどうか（タッチデバイスのみ）0 or 1
    // default: 0
    showWrapLink: {
      type: String,
      default: '0'
    },
    // Bodyブロックを表示するかどうか 0 or 1
    // default: 1
    showBody: {
      type: String,
      default: '1'
    },
    // Price表示をするかどうか 0 or 1
    // default: 1
    showPrice: {
      type: String,
      default: '1'
    },
    // アクション部分（Add to cart, Add to wish list）を表示するかどうか 0 or 1
    // default: 1
    showAction: {
      type: String,
      default: '1'
    },
    // ラベルを表示するかどうか 0 or 1
    // default: 1
    showLabel: {
      type: String,
      default: '1'
    },
    // レビュー★を表示するかどうか 0 or 1
    // default: 1
    showReview: {
      type: String,
      default: '1'
    },
    // ランキング順位を表示するかどうか 0 or 1
    // default: 0
    showRank: {
      type: String,
      default: '0'
    },
    // ランキング順位
    // default: 0
    rank: {
      type: Number
    },

    /*
    Analytics config
    */
    // GA 拡張EC の impression に送信するリスト名
    impressionList: {
      type: String,
      default: ''
    },
    // GA 拡張EC の impression に送信するカスタム値
    impressionDimension1: {
      type: String
    },

    // GA Event category
    analyticsCategory: {
      type: String,
      default: 'EC'
    },
    // GA Event action
    analyticsAction: {
      type: String,
      default: 'Clicked'
    },
    // GA Event label
    analyticsLabel: {
      type: String,
      default: 'ListItem_%s'
    },

    // Tracking category
    trackingCategory: {
      type: String
    },
    // Tracking action
    trackingAction: {
      type: String
    },
    // Tracking label
    trackingLabel: {
      type: String
    },
    // Tracking option 1
    trackingOption1: {
      type: String
    },
    // Tracking option 2
    trackingOption2: {
      type: String
    }
  }
};
